import dotenv from 'dotenv';

dotenv.config();

export const config = () => ({
  appEnv: process.env.VUE_APP_ENV || 'local',
  baseURL: process.env.VUE_APP_SERVICE_URL || 'https://bwell.jumpittlabs.cl',
  timeout: 120000,
  // Single API prefix: core serves every module (auth, ticket, company,
  // insurance, v1 and v2) under /api. The per-service proxy prefixes are
  // gone with the proxy.
  apiPrefix: process.env.VUE_APP_API_PREFIX_URL || '/api/',
  dsn: process.env.VUE_APP_SENTRY_DSN,
  apiVersion: {
    v1: 'v1',
    v2: 'v2'
  },
  gitTag: process.env.VUE_APP_GIT_TAG_VERSION || '0.0.0'
});

export default config;
